<div id="anchor-download" class="container-fluid block">
    <div class="row box">
        <h1 class="title text-center col-12">Pobierz ebooka</h1>
        <p
                class="description col-md-4 offset-md-4 col-lg-6 offset-lg-3 text-center my-4"
        >
            Pobranie ebooka jest bezpłatne. Publikacja udostępniana jest na licencji Creative Commons BY-NC-SA 4.0. Do pobrania możliwe są też edytowalne wersje dokumentów, w tym szczególności wzoru statutu. Dokumenty te można swobodnie modyfikować i dostosowywać do potrzeb konkretnej szkoły, są one dostępne w domenie publicznej.
        </p>
        <div class="col-12 d-flex justify-content-center mt-3">
            <a class="download-link" href="https://static.sus.org.pl/statut.pdf" download>
                <button class="btn-download">POBIERZ STATUT (PDF)</button>
            </a>
        </div>
    </div>
</div>

<style>
    a {
        text-decoration: none;
    }

    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        min-height: 100vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 36px;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;

        color: #425466;
    }

    .btn-download {
        border: none;
        outline: none;
        background-color: #fdcd18;
        color: #425466;
        font-family: "Montserrat";
        font-weight: bold;
        font-size: 18px;
        padding: 14px 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        cursor: pointer;
    }

    .btn-download i {
        font-size: 28px;
    }

    h3 {
        font-family: Work Sans;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
    }

    @media only screen and (max-width: 576px) {
        .download-buttons {
            margin: 0;
            padding: 0;
        }
    }
</style>
